<template>
	<div>
		<h3>Made with ❤️ by Varun487</h3>
	</div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style scoped>
</style>
